export const TAX_TO_BE_CALCULATED_NAME = "To Be Calculated"
export const TAX_NOT_ESTIMATED_NAME = "Tax Not Estimated"
